import React from "react";

const Error = ({ msg }) => {
  return (
    <div className="bg-slate-100 text-red-400 font-semibold text-base tracking-wide text-center py-2">
      {msg}
    </div>
  );
};

export default Error;
